import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import { Button, MultiSearch } from '@offerzen/pinata'
import styles from './style'

const SkillsFilter = ({ skills, filterValues, onApply, validateSkillsSelected, closeFilter }) => {
  const mappedSkills = skills.map(skill => {
    return { label: skill.name, value: skill.name }
  })

  const [selectedSkills, setSelectedSkills] = useState([])
  const [keyword, setKeyword] = useState('')
  const [results, setResults] = useState([])
  const [fetching, setFetching] = useState(false)

  const onSearch = () => {
    setFetching(true)
    const filteredSkills = mappedSkills.filter(skill => skill.label.toLowerCase().includes(keyword.toLowerCase()))
    setResults(filteredSkills)
    // TODO: Remove this timeout
    // Hack so that results load in the skills MultiSearch
    // Without the timeout no results load
    setTimeout(() => setFetching(false), 300)
  }

  useEffect(() => {
    if (!filterValues) return
    setSelectedSkills(
      filterValues?.map(skill => ({
        label: skill.name,
        value: skill.value,
      })),
    )
  }, [filterValues])

  useEffect(() => {
    validateSkillsSelected(selectedSkills)
  }, [selectedSkills])

  return (
    <section role="skills-filter" className={styles.wrapper}>
      <MultiSearch
        autoFocus={true}
        canSelectSearchTerm={!results.length}
        className={styles.search}
        fetching={fetching}
        name="skills-filter"
        noResultsText="No results..."
        onChange={valueArray => {
          const searchKeyword = valueArray.find(item => !item.value)
          const newValue = valueArray.filter(item => !!item.value)
          if (!searchKeyword) {
            setKeyword('')
          } else {
            setKeyword(searchKeyword.label?.toLowerCase())
          }
          if (newValue.length) {
            const newSkillSet = [...selectedSkills]
            newSkillSet.push(newValue)
            setSelectedSkills(newValue)
          }

          onApply(
            newValue.length > 0
              ? newValue.map(skill => ({
                  name: skill.label,
                  value: skill.value,
                }))
              : null,
          )
        }}
        onRemove={skill => {
          setSelectedSkills([...selectedSkills].filter(item => item.value !== skill.value))
        }}
        onSearch={onSearch}
        placeholder="Search for skills"
        results={results}
        theme="primary"
        helpText="Skills include languages, databases, frameworks, tools and methodologies"
        value={[
          ...selectedSkills,
          {
            label: keyword || '',
          },
        ]}
      />
      <div className={styles.buttonWrapper}>
        <div className={styles.action}>
          <Button label="Apply" size="medium" theme="primary" onClick={closeFilter} />
        </div>
      </div>
    </section>
  )
}

SkillsFilter.propTypes = {
  onApply: PropTypes.func,
  filterValues: PropTypes.func,
  skills: PropTypes.array,
  validateSkillsSelected: PropTypes.func,
  closeFilter: PropTypes.func,
}

export default SkillsFilter
